import React from "react";

function PostContent({ post }) {
  return (
    <div className="searchPostContent">
      <p className="textContent">{post?.content}</p>
    </div>
  );
}

export default PostContent;
